import type { ButtonHTMLAttributes } from 'react';
import { cssVars } from '@/lib/cssVars';
import { cx } from '@/lib/cx';
import { Icon, type IconName } from './Icon';
import styles from './RoundIconButton.module.css';

interface RoundIconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: IconName;
  label: string;
  /** Diameter in design units. */
  size: number;
}

/** Glossy blue round button with a white glyph, for actions without painted art. */
export function RoundIconButton({
  icon,
  label,
  size,
  className,
  style,
  ...rest
}: RoundIconButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      className={cx(styles.button, className)}
      style={{ ...cssVars({ '--size': size }), ...style }}
      {...rest}
    >
      <Icon name={icon} className={styles.icon} />
    </button>
  );
}
